module.exports = __webpack_public_path__ + "img/img-contacto.dd4033e0.png";